import React from "react";

const SVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 6L18 18M18 6L6 18" stroke="#26282B" stroke-width="2" stroke-linecap="round"/>
</svg>
`;

export const CloseIcon = ({ onClick }: { onClick?: () => void }) => (
  <div
    style={{ display: "flex" }}
    className="CloseIcon"
    dangerouslySetInnerHTML={{ __html: SVG }}
    onClick={onClick}
  />
);
